import { gql } from '@guuru/graphql-common/gql';

export default gql(`#graphql
  query GetUserEmail($id: ID!) {
    chat(id: $id) {
      id
      user {
        id
        email
      }
    }
  }
`);
